import { Hero } from "@/sections/home/Hero";
import { TechMarquee } from "@/sections/home/TechMarquee";
import { MetricsStrip } from "@/sections/home/MetricsStrip";
import { Qualifiers } from "@/sections/home/Qualifiers";
import { HowItWorks } from "@/sections/home/HowItWorks";
import { IcpFramework } from "@/sections/home/IcpFramework";
import { ServicesBento } from "@/sections/home/ServicesBento";
import { Comparison } from "@/sections/home/Comparison";
import { CaseStudies } from "@/sections/home/CaseStudies";
import { Process } from "@/sections/home/Process";
import { Faq } from "@/sections/home/Faq";
import { CtaBand } from "@/components/CtaBand";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <TechMarquee />
      <MetricsStrip />
      <Qualifiers />
      <HowItWorks />
      <IcpFramework />
      <ServicesBento />
      <Comparison />
      <CaseStudies />
      <Process />
      <Faq />
      <CtaBand />
    </div>
  );
}
